module.exports = __webpack_public_path__ + "img/fc-krasnodar.ae13f8be.png";